import { create } from 'zustand';

import { LOCAL_STORAGE_KEYS } from '../utils/common/local-storage-keys';
import { createSelectors } from '../utils/zustand/createSelectors';

interface RefrigeratorNotificationState {
  /** 마이냉장고 알림 상태 */
  refrigeratorNotification: number[] | null;

  /** 마이냉장고 알림 설정 (localStorage 동기화) */
  setRefrigeratorNotification: (
    refrigeratorNotification: number[] | null,
  ) => void;
}

// 초기값을 localStorage에서 가져오기 (클라이언트 사이드에서만)
const getInitialRefrigeratorNotification = (): number[] | null => {
  if (typeof window === 'undefined') return null;

  const savedValue = window.localStorage.getItem(
    LOCAL_STORAGE_KEYS.REFRIGERATOR_NOTIFICATION,
  );

  if (savedValue === null) return null;

  try {
    return JSON.parse(savedValue);
  } catch {
    return [];
  }
};

/**
 * 마이냉장고 알림 상태를 관리하는 Zustand store
 * - localStorage와 JSON 형태로 동기화
 * - 마이냉장고 알림 목록 관리
 */
const useRefrigeratorNotificationStoreBase =
  create<RefrigeratorNotificationState>((set) => ({
    refrigeratorNotification: getInitialRefrigeratorNotification(),
    setRefrigeratorNotification: (
      refrigeratorNotification: number[] | null,
    ) => {
      set({ refrigeratorNotification });

      // localStorage 동기화 (JSON으로 저장)
      if (typeof window !== 'undefined') {
        if (refrigeratorNotification === null) {
          window.localStorage.removeItem(
            LOCAL_STORAGE_KEYS.REFRIGERATOR_NOTIFICATION,
          );
        } else {
          window.localStorage.setItem(
            LOCAL_STORAGE_KEYS.REFRIGERATOR_NOTIFICATION,
            JSON.stringify(refrigeratorNotification),
          );
        }
      }
    },
  }));

export const useRefrigeratorNotificationStore = createSelectors(
  useRefrigeratorNotificationStoreBase,
);
